// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Labels = require("../../../reason/clients/components/Labels.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ForSalePropertyLabels_property_graphql = require("../../../__generated__/ForSalePropertyLabels_property_graphql.bs.js");

var convertFragment = ForSalePropertyLabels_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ForSalePropertyLabels_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ForSalePropertyLabels_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ForSalePropertyLabels_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ForSalePropertyLabels_property_graphql.node, convertFragment, fRef);
}

var PropertyFragment_forSalePropertyMatchingType_decode = ForSalePropertyLabels_property_graphql.Utils.forSalePropertyMatchingType_decode;

var PropertyFragment_forSalePropertyMatchingType_fromString = ForSalePropertyLabels_property_graphql.Utils.forSalePropertyMatchingType_fromString;

var PropertyFragment = {
  forSalePropertyMatchingType_decode: PropertyFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: PropertyFragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ForSalePropertyLabels(props) {
  var property = use(props.property);
  var match = property.agentV2;
  var match$1 = property.forSaleMatchingType;
  if (match$1 !== undefined && (match$1 === "QUIET" || match$1 === "ONE_WAY" || match$1 === "BROADCAST" || match$1 === "QUIET_ANONYMOUS")) {
    switch (match$1) {
      case "QUIET" :
          return JsxRuntime.jsx(Labels.QuietSellerLabel.make, {});
      case "QUIET_ANONYMOUS" :
          return JsxRuntime.jsx(Labels.AnonymousMatchingLabel.make, {});
      default:
        
    }
  }
  if (match !== undefined && match.__typename === "AnonymousForSalePropertyAgent") {
    return JsxRuntime.jsx(Labels.AnonymousAgentLabel.make, {});
  } else {
    return null;
  }
}

var make = ForSalePropertyLabels;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* Labels Not a pure module */
